module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('isrs-settings-dialog', {
    attrs: {
      "fields": _vm.fields,
      "input-form-fields-activated": _vm.configActivated,
      "input-form-data": _vm.config
    },
    on: {
      "formDataChanged": function (config) { return _vm.saveConfig(config); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-700dfd2f"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/PreadviseSettings.vue
// module id = 942
// module chunks = 1